define("shared/components/shared/post/secondary/publishing-method-setup/layout/index", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--modalCard--secondary">
    <section
      class={{concat-classes
        "o--modalBody--secondary has--noHeader u--p__tb__lg"
        (if (has-block "footer") "has--tallFooter")
      }}
      {{perfect-scroll}}
    >
      {{#if @image}}
        <div class="cPM--secondary__image">
          <img alt={{html-safe @title}} class="o--media" src={{@image}} />
        </div>
      {{/if}}
      <h2
        class={{if
          @image
          "o--modalHeader__title u--text--lg u--m__b u--m__t__md"
          "o--modalHeader__title u--text--lg u--m__b"
        }}
      >
        {{html-safe @title}}
      </h2>
      {{yield to="body"}}
    </section>
    {{#if (has-block "footer")}}
      <section class="o--modalFooter">
        {{yield to="footer"}}
      </section>
    {{/if}}
  </div>
  */
  {
    "id": "AQuvaK/r",
    "block": "[[[10,0],[14,0,\"o--modalCard--secondary\"],[12],[1,\"\\n  \"],[11,\"section\"],[16,0,[28,[37,0],[\"o--modalBody--secondary has--noHeader u--p__tb__lg\",[52,[48,[30,3]],\"has--tallFooter\"]],null]],[4,[38,3],null,null],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[10,0],[14,0,\"cPM--secondary__image\"],[12],[1,\"\\n        \"],[10,\"img\"],[15,\"alt\",[28,[37,4],[[30,2]],null]],[14,0,\"o--media\"],[15,\"src\",[30,1]],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,\"h2\"],[15,0,[52,[30,1],\"o--modalHeader__title u--text--lg u--m__b u--m__t__md\",\"o--modalHeader__title u--text--lg u--m__b\"]],[12],[1,\"\\n      \"],[1,[28,[35,4],[[30,2]],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[18,4,null],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[48,[30,3]],[[[1,\"    \"],[10,\"section\"],[14,0,\"o--modalFooter\"],[12],[1,\"\\n      \"],[18,3,null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@image\",\"@title\",\"&footer\",\"&body\"],false,[\"concat-classes\",\"if\",\"has-block\",\"perfect-scroll\",\"html-safe\",\"yield\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/layout/index.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});